import MemriseApi from '../MemriseApi';
import { SourceLanguagesResponse } from './schema';

export default class LanguageApiClass extends MemriseApi {
  constructor() {
    super({ endpointPrefix: '/language-pairs' });
  }

  public async getSourceLanguage(sourceLanguage: string): Promise<SourceLanguagesResponse> {
    return await this.get(`/?source_language=${sourceLanguage}`);
  }
}

export const LanguageApi = new LanguageApiClass();
